module.exports = __webpack_public_path__ + "img/teenies.c85a6e96.svg";